import moment from "moment-timezone";
import { getTimeZones } from "@vvo/tzdb";
import { TimezoneOption } from "../timezones.types";

export const getUserTimezone = (
  timezones: TimezoneOption[]
): TimezoneOption | null => {
  let clientIana = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const timeZones = getTimeZones({ includeUtc: true });

  // Try to match what Intl gave us
  let foundTimezone = clientIana
    ? timeZones.find((z) => z.name === clientIana)
    : null;

  if (foundTimezone) {
    return timezones.find((z) => z.name === foundTimezone!.name) ?? null;
  } else {
    // fallback to moment's guess
    clientIana = moment.tz.guess();

    const fallbackTimezone = timeZones.find((z) => z.name === clientIana) ?? null;

    return fallbackTimezone
      ? timezones.find((z) => z.name === fallbackTimezone.name) ?? null
      : null;
  }
};

export default getUserTimezone;

